module.exports = __webpack_public_path__ + "static/img/icon-lab-01.f21d64e5.png";